import { cn } from '@/lib/utils';

export interface SpreadStrikesProps {
  shortStrike: number;
  longStrike: number;
  optionType: 'put' | 'call';
  shortDelta?: number;
  className?: string;
}

/**
 * Renders a spread's strikes as "Sell 505 / Buy 495 P" with consistent
 * red/blue color coding. Sell (short) strike always appears first.
 */
export function SpreadStrikes({
  shortStrike,
  longStrike,
  optionType,
  shortDelta,
  className,
}: SpreadStrikesProps) {
  const suffix = optionType === 'put' ? 'P' : 'C';
  const shortStrikeStr = shortStrike % 1 === 0 ? shortStrike.toString() : shortStrike.toFixed(2);
  const longStrikeStr = longStrike % 1 === 0 ? longStrike.toString() : longStrike.toFixed(2);

  return (
    <span className={cn('font-mono text-xs', className)}>
      <span className="text-red-600">Sell {shortStrikeStr}</span>
      <span className="text-gray-400"> / </span>
      <span className="text-blue-600">Buy {longStrikeStr}</span>
      <span className="text-gray-500">{suffix}</span>
      {shortDelta != null && (
        <span className="text-gray-400 ml-1">({shortDelta.toFixed(0)}δ)</span>
      )}
    </span>
  );
}
